import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { CompareFilledIcon, Tooltip } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { COLORS } from "../../../../constants/common";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var CmpButton = function CmpButton(_ref) {
  var isInCmp = _ref.isInCmp,
    tooltipMsgPos = _ref.tooltipMsgPos,
    onCmpClick = _ref.onCmpClick,
    tooltipMsg = _ref.tooltipMsg;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCmpHovered = _useState2[0],
    setIsCmpHovered = _useState2[1];
  return onCmpClick ? /*#__PURE__*/React.createElement("div", {
    className: cx('cmp-wrapper'),
    onClick: onCmpClick,
    onMouseEnter: function onMouseEnter() {
      return setIsCmpHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsCmpHovered(false);
    },
    role: "button",
    tabIndex: 0
  }, isInCmp ? /*#__PURE__*/React.createElement(CompareFilledIcon, {
    fill: COLORS.BLACK,
    size: "s"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, isCmpHovered && tooltipMsg && /*#__PURE__*/React.createElement(Tooltip, {
    message: tooltipMsg || '',
    position: tooltipMsgPos || 'bottom'
  }, /*#__PURE__*/React.createElement(CompareFilledIcon, {
    fill: COLORS.RED,
    size: "s"
  })), isCmpHovered && !tooltipMsg && /*#__PURE__*/React.createElement(CompareFilledIcon, {
    fill: COLORS.RED,
    size: "s"
  }), !isCmpHovered && /*#__PURE__*/React.createElement(CompareFilledIcon, {
    fill: COLORS.GRAY_INACTIVE,
    size: "s"
  }))) : null;
};